import { useEffect } from 'react';
import { navigate } from "@reach/router"

const MiddlefieldFireCompanyPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/emergency-services/');
  }, []);
  return null;
};

export default MiddlefieldFireCompanyPage;